import {
    Card,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableRow,
    Box
} from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2"; // Grid version 2
import { useState, useEffect } from "react";
import { useClient } from "../../../context/ClientProvider";
import ActionButton from "../../account/ActionButton";
import { formatCurrency } from '../../../utils/formatCurrency';


function createData(id, title, value) {
    return { id, title, value };
}

function EarlySettlementCard({ requestedDate, expirationDate, settlementAmount }) {
    const [localPalette, setLocalPalette] = useState(null);
    const { useGetConfig } = useClient();
    const { clientConfig } = useGetConfig();
    useEffect(() => {
        if (clientConfig && clientConfig?.theme?.palette) {
            setLocalPalette(clientConfig.theme.palette);
        }
    }, [clientConfig]);
    let cardData = [
        createData(
            "agreed-settlement-date",
            "Agreed settlement date: ",
            requestedDate
        ),
        createData(
            "pay-by-date",
            "Pay by date: ",
            expirationDate
        ),
        createData(
            "full-early-settlement-amount",
            "Full early settlement amount: ",
            formatCurrency(settlementAmount)
        )
    ]
    return localPalette && (
        <Grid>
            <Card
                id="balance-container"
                sx={{
                    textAlign: "left",
                    backgroundColor: "primary.dark",
                    color: "primary.contrastText",
                    borderRadius: 0,
                    borderLeft: `10px solid ${localPalette.secondary.dark}`
                }}>
                <Typography
                    id="balance-label"
                    fontWeight={"bold"}
                    fontSize={24}
                    paddingTop={1}
                    marginLeft={2}
                >
                    Early Settlement
                </Typography>
                <TableContainer sx={{ py: 1, px: 1}}>
                    <Table
                        sx={{ minWidth: "100%" }}
                        size='small'
                        aria-label='repayment plan table'
                    >
                        <TableBody>
                            {cardData.map((row) => (
                                <TableRow
                                    key={row.title}
                                    sx={{
                                        "td, th": { border: 0 },
                                        th: { color: "#FFF" },
                                        td: { color: "#FFF" },
                                    }}
                                >
                                    <TableCell
                                        sx={{ fontWeight: "bold" }}
                                        component='th'
                                        scope='row'
                                    >
                                        {row.title}
                                    </TableCell>
                                    <TableCell id={row.id} align='right'>
                                        {row.value}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>

                <Box sx={{ textAlign: "center", pt: 2, pb: 4 }}>
                    <ActionButton
                        id='make-early-settlement-repayment-btn'
                        buttonColor='secondary.dark'
                        buttonTextColor='primary.contrastText'
                        buttonTitle='Make early settlement repayment'
                        hoverColor='primary.contrastText'
                        hoverTextColor='secondary.dark'
                        target='/payment'
                    />
                </Box>
            </Card>
        </Grid>
    )
}

export default EarlySettlementCard;